import { useEffect, useState } from "react";
import Slider from "@mui/material/Slider";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import "./Level.css";
import {
  cbset,
  complist,
  getcb,
  getlevel,
} from "../../components/funtionsBD/Mainservice";
import { ExerciseTypeMark } from "../../components/ExerciseTypeMark";
import { competencyBlockIconSrc } from "../../utils/competencyBlockIcon";

const Level = () => {
  const [levels, setlevels] = useState();
  const [selectedlevel, setselectedlevel] = useState();
  const [CB, setCB] = useState();
  const [open, setopen] = useState(false);
  const [open2, setopen2] = useState(false);
  const [error, seterror] = useState("");
  const [success, setsuccess] = useState("");
  const [list, setlist] = useState([]);
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    getdata();
  }, []);

  const getdata = async () => {
    try {
      const response = await getcb();
      const response2 = await getlevel();
      console.log('🔍 Level API Response:', response2.data);
      console.log('🔍 Levels data:', response2.data.data);
      if (response2.data && response2.data.data && response2.data.data.length > 0) {
        setlevels(response2.data.data);
        setselectedlevel(response2.data.data[0].level_id);
      } else {
        console.log('❌ No levels data received');
        setlevels([]);
      }
      if (response.data.data.length > 0) {
        setCB(true);
        const data = response.data.data;
        setlist(data);
      } else {
        const response = await complist();
        const data = response.data.data;
        const updatedList = data.map((item) => {
          return { ...item, cb_score: 1 };
        });
        setlist(updatedList);
        setCB(false);
      }
    } catch (error) {
      seterror(error.message);
      setopen2(true);
    }
  };

  const handleset = async () => {
    try {
      const newArray = list.map((item) => ({
        cb_id: item.cb_id,
        cb_score: item.cb_score,
      }));
      const response = await cbset(newArray);
      setsuccess(response.data.message);
      setopen(true);
      setTimeout(() => {
        navigate("/home");
      }, 1000);
    } catch (error) {
      console.log(error);
      navigate("/home");
    }
  };

  const handlescore = (value, cb) => {
    const updatedList = list.map((item) => {
      if (item.cb_id === cb.cb_id) {
        return { ...item, cb_score: value };
      }
      return item;
    });
    setlist(updatedList);
  };

  return (
    <>
      <div id="adminRoot">
        <div className="exercise-header">
          <h2>{t("competencyblock")}</h2>
        </div>
        <div className="level_div">
          <div className="input-detail">
            <p className="level_title">{t("welcomemsg")}</p>
            <label>{t("chooselevel")}</label>
            <select
              onChange={(e) => setselectedlevel(e.target.value)}
              className="select_level"
              style={{ backgroundColor: "#fff" }}
            >
              {levels && levels.length > 0 ? levels.map((l, index) => {
                console.log('🔍 Rendering level option:', l);
                const displayName = l.level_name || l.level_description || l.level_id || 'Unknown Level';
                return (
                  <option key={index} value={l.level_id}>
                    {displayName}
                  </option>
                );
              }) : (
                <option value="">Loading levels...</option>
              )}
            </select>
            <p className="level_des">{t("levelmsg")} </p>
          </div>
          {list.map((i, index) => (
            <div key={index} className="comp_level_card">
              {competencyBlockIconSrc(i) ? (
                <ExerciseTypeMark src={competencyBlockIconSrc(i)} />
              ) : null}
              <div className="comp_level_info">
                <div className="comp_level_value">
                  <p>{i.cb_name_en}</p>
                  <p>{i.cb_score}</p>
                </div>
                <Slider
                  value={i.cb_score}
                  onChange={(e, v) => handlescore(v, i)}
                  getAriaValueText={() => i.cb_score}
                  step={1}
                  min={1}
                  max={10}
                  valueLabelDisplay="auto"
                />
              </div>
            </div>
          ))}

          <div className="input-detail">
            <button className="w-100" onClick={handleset}>
              {t("update")}
            </button>
          </div>
        </div>
      </div>
      <Snackbar
        open={open}
        autoHideDuration={4000}
        onClose={() => setopen(false)}
      >
        <Alert variant="filled" severity="success">
          {success}
        </Alert>
      </Snackbar>
      <Snackbar
        open={open2}
        autoHideDuration={4000}
        onClose={() => setopen2(false)}
      >
        <Alert variant="filled" severity="error">
          {error}
        </Alert>
      </Snackbar>
    </>
  );
};
export default Level;
